// iOS Safari clears a site's stored data (the browser wallet included) after seven
// days of Safari use without a visit; a site added to the Home Screen is exempt.
// Browser-wallet accounts on iOS are asked once to add Treechat there.

type NavigatorLike = {
    userAgent?: string
    platform?: string
    maxTouchPoints?: number
    standalone?: boolean
}

const DISMISSED_KEY_PREFIX = 'treechat-home-screen-nudge-dismissed:'

/** An iPhone, iPod or iPad browser (iPadOS reports itself as a Mac with touch). */
export function isIosBrowser(nav: NavigatorLike | undefined = globalThis.navigator): boolean {
    if (!nav) return false
    const ua = nav.userAgent || ''
    return (
        /iPad|iPhone|iPod/.test(ua) ||
        (nav.platform === 'MacIntel' && (nav.maxTouchPoints || 0) > 1)
    )
}

/** Already opened from the Home Screen. */
export function isStandaloneApp(
    nav: NavigatorLike | undefined = globalThis.navigator,
    matchMedia: ((query: string) => { matches: boolean }) | undefined = globalThis.matchMedia,
): boolean {
    if (nav?.standalone === true) return true
    try {
        return !!matchMedia?.('(display-mode: standalone)').matches
    } catch (_error) {
        return false
    }
}

export function homeScreenNudgeDismissed(
    userId: string,
    storage: Pick<Storage, 'getItem'> | undefined = globalThis.localStorage,
): boolean {
    try {
        return storage?.getItem(`${DISMISSED_KEY_PREFIX}${userId}`) === '1'
    } catch (_error) {
        return false
    }
}

export function dismissHomeScreenNudge(
    userId: string,
    storage: Pick<Storage, 'setItem'> | undefined = globalThis.localStorage,
) {
    try {
        storage?.setItem(`${DISMISSED_KEY_PREFIX}${userId}`, '1')
    } catch (_error) {
        // Without storage the nudge simply shows again next visit.
    }
}
